import { array, boolean, intersect, nullable, partial, string, struct } from 'io-ts/Decoder';

import { Id as ClientId } from '../client/Id';
import { Id as OrganizationId } from '../organization/Id';

import { Id } from './Id';

export const RefItem = intersect(
	struct({
		id: Id,
	})
)(
	partial({
		name: string,
		transactionRef: nullable(string),
		organizationId: OrganizationId,
		clientIds: array(ClientId),
		clientId: nullable(ClientId),
		targetAt: nullable(string),

		isDeleted: boolean,
		/** [ROME-125] the job (or the transaction's job) is soft or deep archived: read-only */
		isArchived: boolean,
		isUnknown: boolean,
	})
);
